import api from '@/api';
import { createRequest, saveParamsToQuery } from '@/utils/helpers';

let currentTicketListRequest = null;
let detailsRequest = null;
let objectsListRequest = null;

const admin = {
  namespaced: true,

  state() {
    return {
      isLoading: false,
      organizations: {
        page: 1,
        pageCount: 0,
        list: [],
      },
      organizationCheckInterval: null,
      customerUnauthorizedQuantity: null,
      partnerUnauthorizedQuantity: null,
      genContractorUnauthorizedQuantity: null,
      currentOrganizationID: null,
      organizationDetails: {},
      organizationsFilters: {},
      customerOrganizationsSearch: '',
      partnerOrganizationsSearch: '',
      genContractorOrganizationsSearch: '',
      onlyUncredited: false,
      objectsSearch: '',
      objects: {
        page: 1,
        pageCount: 0,
        list: [],
      },
      objectDetails: {},
      objectsFilters: {},
      plannedLotsFile: null,
      materialGuideFile: null,
      customersList: [],
    };
  },

  mutations: {
    setGenContractorFilters(state, { search, onlyUncredited }) {
      state.genContractorOrganizationsSearch = search;
      state.onlyUncredited = onlyUncredited;
    },
    setOrganizations(state, value) {
      const data = {
        page: value.page,
        pageCount: value.pageCount,
        list: value.organizations,
      };
      state.organizations = data;
    },
    setCurrentOrganizationID(state, id) {
      state.currentOrganizationID = id;
    },
    setOrganizationDetails(state, value) {
      state.organizationDetails = value;
    },
    setOrganizationsPage(state, page) {
      state.organizations.page = page;
    },
    setCustomerOrganizationsSearch(state, search) {
      state.customerOrganizationsSearch = search;
    },
    setPartnerOrganizationsSearch(state, search) {
      state.partnerOrganizationsSearch = search;
    },
    setObjectsSearch(state, search) {
      state.objectsSearch = search;
    },
    setOrganizationsFilters(state, params) {
      state.organizationsFilters = { ...params };
    },
    setPlannedLotsFile(state, fileUrl) {
      state.plannedLotsFile = fileUrl;
    },
    setMaterialGuideFile(state, fileUrl) {
      state.materialGuideFile = fileUrl;
    },
    setObjectsList(state, value) {
      const data = {
        page: value.page,
        pageCount: value.pageCount,
        list: value.objects,
      };
      state.objects = data;
    },
    setObjectsPage(state, page) {
      state.objects.page = page;
    },
    addContractors(state, id) {
      state.objectDetails[id].contractors.push({ new: true });
    },
    deleteContractor(state, { id, index }) {
      state.objectDetails[id].contractors.splice(index, 1);
    },
    changeContractors(state, {
      objectId, index, id, title,
    }) {
      state.objectDetails[objectId].contractors[index] = {
        id,
        title,
      };
    },
    setObjectDetails(state, { id, result }) {
      const data = {
        storages: result.storages,
        contractors: result.contractors,
      };
      state.objectDetails[id] = data;
    },
    setObjectsFilters(state, params) {
      state.objectsFilters = { ...params };
    },
    changeLoading(state, status) {
      state.isLoading = status;
    },
    setCustomersList(state, items) {
      state.customersList = items;
      console.log(items);
    },
    setGeneralContractorsSearch(state, search) {
      state.genContractorOrganizationsSearch = search;
    },
    setPartnerUnauthorizedQuantity(state, value) {
      state.partnerUnauthorizedQuantity = value;
      console.log(value);
    },
    setCustomerUnauthorizedQuantity(state, value) {
      state.customerUnauthorizedQuantity = value;
    },
    setGenContractorUnauthorizedQuantity(state, value) {
      state.genContractorUnauthorizedQuantity = value;
    },
    setOrganizationCheckInterval(state, value) {
      state.organizationCheckInterval = value;
    },
  },

  actions: {
    async fetchOrganizationsUnauthorizedCount({ state, commit, dispatch }) {
      clearInterval(state.organizationCheckInterval);

      try {
        // Партнеры и заказчики с неутвержденными пользователями, генподрядчики с заявкой «Требует обработки»
        const { data } = await api.admin.organizations.unauthorizedCounts();
        commit('setPartnerUnauthorizedQuantity', data.result.partners);
        commit('setCustomerUnauthorizedQuantity', data.result.customers);
        commit('setGenContractorUnauthorizedQuantity', data.result.genContractors);

        const interval = setInterval(() => {
          dispatch('fetchOrganizationsUnauthorizedCount');
        }, 10000);

        commit('setOrganizationCheckInterval', interval);
      } catch (e) {
        console.error(e);
      }
    },
    setObjectsSearch({ commit, dispatch }, search) {
      commit('setObjectsSearch', search);
      dispatch('setObjectsPage', 1);
    },
    async setObjectsPage({ commit, dispatch }, page) {
      commit('setObjectsPage', page);
      await dispatch('loadObjectsList');
    },
    setPartnerOrganizationsSearch({ commit, dispatch }, search) {
      commit('setPartnerOrganizationsSearch', search);
      dispatch('setOrganizationsPage', 1);
    },
    setCustomerOrganizationsSearch({ commit, dispatch }, search) {
      commit('setCustomerOrganizationsSearch', search);
      dispatch('setOrganizationsPage', 1);
    },
    async setOrganizationsPage({ commit, dispatch, rootState }, page) {
      commit('setOrganizationsPage', page);
      const dispatchType = rootState.appService.filterType === 'PartnerOrganizations'
        ? 'loadPartnerList'
        : 'loadCustomerList';
      await dispatch(dispatchType);
    },
    async setGeneralContractorsPage({ commit, dispatch }, page) {
      commit('setOrganizationsPage', page);
      await dispatch('loadGenconctractorList');
    },
    setGeneralContractorsSearch({ commit, dispatch }, search) {
      commit('setGeneralContractorsSearch', search);
      dispatch('setGeneralContractorsPage', 1);
    },
    async loadPartnerList({ state, commit }) {
      try {
        commit('changeLoading', true);
        if (currentTicketListRequest) {
          return;
        }
        const params = createRequest({
          pageSize: 10,
          page: state.organizations.page,
          name: state.partnerOrganizationsSearch,
          ...state.organizationsFilters,
        });
        currentTicketListRequest = api.admin.organizations.partnerList(params);
        const { data } = await currentTicketListRequest;
        saveParamsToQuery({ page: params.page, search: params.name });
        commit('setOrganizations', data.result);
        commit('changeLoading', false);
        currentTicketListRequest = null;
      } catch (e) {
        currentTicketListRequest = null;
        commit('changeLoading', false);
        console.error(e);
      }
    },
    async loadCustomerList({ state, commit }) {
      try {
        commit('changeLoading', true);
        if (currentTicketListRequest) {
          return;
        }
        const params = createRequest({
          pageSize: 10,
          page: state.organizations.page,
          name: state.customerOrganizationsSearch,
          ...state.organizationsFilters,
        });
        currentTicketListRequest = api.admin.organizations.customerList(params);
        const { data } = await currentTicketListRequest;
        saveParamsToQuery({ page: params.page, search: params.name });
        commit('setOrganizations', data.result);
        commit('changeLoading', false);
        currentTicketListRequest = null;
      } catch (e) {
        currentTicketListRequest = null;
        commit('changeLoading', false);
        console.error(e);
      }
    },
    async loadGenconctractorList({ state, commit }) {
      try {
        commit('changeLoading', true);
        if (currentTicketListRequest) {
          return;
        }

        const params = createRequest({
          pageSize: 10,
          page: state.organizations.page,
          string: state.genContractorOrganizationsSearch,
          onlyUncredited: state.onlyUncredited || null,
        });
        currentTicketListRequest = api.admin.gencontractors.list(params);
        const { data } = await currentTicketListRequest;
        saveParamsToQuery({ page: params.page, search: params.name });
        commit('setOrganizations', {
          ...data.result,
          organizations: data.result.genContractors,
        });
        commit('changeLoading', false);
        currentTicketListRequest = null;
      } catch (e) {
        currentTicketListRequest = null;
        commit('changeLoading', false);
        console.error(e);
      }
    },
    async loadOrganizationDetails({ state, commit }) {
      try {
        commit('changeLoading', true);
        if (detailsRequest) {
          return;
        }
        detailsRequest = api.admin.organizations.details({ id: state.currentOrganizationID });
        const { data } = await detailsRequest;
        commit('setOrganizationDetails', data.result);
        commit('changeLoading', false);
        detailsRequest = null;
      } catch (e) {
        detailsRequest = null;
        commit('changeLoading', false);
        console.error(e);
      }
    },
    async changeOrganizationStatus({ dispatch, commit }, params) {
      try {
        commit('changeLoading', true);
        await api.admin.organizations.changeStatus(params);
        await dispatch('loadOrganizationDetails');
        commit('changeLoading', false);
        return true;
      } catch (e) {
        commit('changeLoading', false);
        console.error(e);
        return false;
      }
    },
    async loadObjectsList({ state, commit, rootState }) {
      try {
        commit('changeLoading', true);
        if (objectsListRequest) {
          return;
        }
        const params = createRequest({
          pageSize: 10,
          page: state.objects.page,
          objectName: state.objectsSearch,
          ...state.objectsFilters,
        });
        objectsListRequest = api.admin.objects.list(params);
        const { data } = await objectsListRequest;
        saveParamsToQuery({ page: params.page, search: params.objectName });
        commit('setObjectsList', data.result);
        commit('changeLoading', false);
        objectsListRequest = null;
      } catch (e) {
        objectsListRequest = null;
        commit('changeLoading', false);
        console.error(e);
      }
    },
    async loadPlannedLots({ commit }) {
      try {
        commit('changeLoading', true);
        const { data } = await api.admin.lots.getPlannedLotsFile();
        commit('setPlannedLotsFile', data.result);
        commit('changeLoading', false);
      } catch (e) {
        commit('changeLoading', false);
        console.error(e);
      }
    },
    async loadMaterialGuideFile({ commit }) {
      try {
        commit('changeLoading', true);
        const { data } = await api.admin.lots.loadMaterialGuideFile();
        commit('setMaterialGuideFile', data.result);
        commit('changeLoading', false);
      } catch (e) {
        commit('changeLoading', false);
        console.error(e);
      }
    },
    async loadObjectDetails({ commit, state }, { id, force }) {
      if (state.objectDetails[id] && !force) {
        return;
      }
      try {
        commit('changeLoading', true);
        const { data } = await api.admin.objects.details({ id });
        const customersList = await api.admin.objects.customersNotifyList(id);
        commit('setObjectDetails', { result: data.result, id });
        commit('setCustomersList', customersList.data.result);
        commit('changeLoading', false);
      } catch (e) {
        commit('changeLoading', false);
        console.error(e);
      }
    },
    async saveObjectContractors({ commit, state, dispatch }, id) {
      try {
        commit('changeLoading', true);
        await api.admin.objects.saveContractors({ id, contractorIds: state.objectDetails[id].contractors.map((cont) => cont.id || cont.key) });
        await dispatch('loadObjectDetails', { id, force: true });
      } catch (e) {
        commit('changeLoading', false);
        console.error(e);
      }
    },
    async saveCustomersList({ commit, state, dispatch }, data) {
      try {
        commit('changeLoading', true);
        await api.admin.objects.saveCustomersList(data);
        await dispatch('loadObjectDetails', { id: data.objectId, force: true });
      } catch (e) {
        commit('changeLoading', false);
        console.error(e);
      }
    },
    async changeUserStatus({ commit, dispatch }, params) {
      try {
        commit('changeLoading', true);
        await api.admin.users.changeStatus(params);
        await dispatch('loadOrganizationDetails');
        commit('changeLoading', false);
        return true;
      } catch (e) {
        commit('changeLoading', false);
        console.error(e);
        return false;
      }
    },
  },

  getters: {},
};

export default admin;
